// extracted by mini-css-extract-plugin
module.exports = {"camIcon":"CamIcon_camIcon__CnWo6"};